import { text, vstack } from '@onbeam/business-styled-system/patterns';
import { TimelineItemProps } from './TimelineItem.types';
import { cx } from '@onbeam/business-styled-system/css';
import { useRef } from 'react';
import { useIsCentered } from '@/helpers/useIsCentered';

export const TimelineItem = ({
  icon: Icon,
  title,
  description,
  position,
  className,
  ...props
}: TimelineItemProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInCenter = useIsCentered(ref, {
    once: true,
  });

  return (
    <div
      ref={ref}
      data-position={position}
      data-active={isInCenter}
      className={cx(
        vstack({
          gap: '4',
          w: '[12.5rem]',
          position: 'absolute',
          alignItems: 'flex-start',
          textAlign: 'left',
          right: '[-3rem]',
          transform: 'translateX(100%)',
          opacity: 0,
          transition: 'opacity',
          transitionDuration: 'normal',

          _active: {
            opacity: 1,
          },
          md: {
            w: '[16.5rem]',
            '&[data-position="left"]': {
              alignItems: 'flex-end',
              textAlign: 'right',
              left: '[-3rem]',
              transform: 'translateX(-100%)',
            },
          },
        }),
        className,
      )}
      {...props}
    >
      <Icon />
      <h3
        className={text({
          style: { base: 'body-xl', md: 'subtitle-sm' },
        })}
      >
        {title}
      </h3>
      <p
        className={text({
          style: 'body-md',
          color: 'mono.tertiary',
        })}
      >
        {description}
      </p>
    </div>
  );
};
